<template>
  <div id="app">
    <main-view></main-view>
  </div>
</template>

<script>

import mainView from "./components/main";
export default {
  name: 'App',
  components: {
    mainView,
  },
  data() {
    return {
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100vh;
  width: 100vw;
}
</style>
